// extracted by mini-css-extract-plugin
export default {"contact":"mediatheque_contact__XsBSc"};